import { Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HandleHttpError, HandleAWSCognitoError } from './error.handler';
import { Store, select } from '@ngrx/store';
// import Auth from '@aws-amplify/auth';
import Amplify, { Auth } from 'aws-amplify';
import { ISignUpResult, CognitoUser } from 'amazon-cognito-identity-js';
import { from } from 'rxjs';
import { ErrorResponse } from '../models/error.model';
import { SharedService } from './shared.service';
import { configureAmplify } from '../config/aws.config';
import { AWS } from '@aws-amplify/core';
import { AWSSettings } from '../models/aws-settings.model';
import 'rxjs/add/observable/of' 


@Injectable()
export class AuthService {

    baseURL: string;
    // userType = '';

    constructor(private http: HttpClient,
                private sharedService: SharedService,
                private store: Store<any>,
                private router: Router) {
                    //console.log('in Auth service constructor');
                    this.baseURL = this.sharedService.getBaseURL();
                    this.init();
                }

    init(): void {

        //console.log('in init of auth.service');

        this.store.pipe(select('shared'))
                .subscribe( sharedState => {

                    //console.log('shared state');
                    //console.log(sharedState);
                    if (sharedState && sharedState.userType) {
                        // this.userType = sharedState.userType;
                        localStorage.setItem('userType', sharedState.userType);
                    }
                    // } else {
                    //     // this.userType = null;
                    //     localStorage.setItem('userType', '');
                    // }
                });
    }



    login(username: string, password: string): Observable<any> {

        // Auth.configure(AuthConfig);
        configureAmplify(false);

        return from( Auth.signIn(username, password))
                .pipe(catchError(err => HandleAWSCognitoError(err)));
    }

    agentLogin(username: string, password: string): Observable<any> {

        // Auth.configure(AgentAuthConfig);
        configureAmplify(true);

        return from( Auth.signIn(username, password))
                .pipe(catchError(err => HandleAWSCognitoError(err)));
    }

    refreshSession(isAgent: boolean) : Observable<any>{
        // this will refresh the token
        console.log('resfresh session');
        configureAmplify(isAgent);

        return from( Auth.currentSession())
                .pipe(catchError(err => HandleAWSCognitoError(err)));
    }

    logout(): Observable<any> {
        return from ( Auth.signOut({ global: true }))
                .pipe(catchError(err => HandleAWSCognitoError(err)));
    }

    forgotPassword(username: string): Observable<any> {
        configureAmplify(false);
        return from ( Auth.forgotPassword(username))
                .pipe(catchError(err => HandleAWSCognitoError(err)));
    }

    resetPassword(username: string, verificationCode: string, newPassword: string): Observable<any> {
        configureAmplify(false);
        return from ( Auth.forgotPasswordSubmit(username, verificationCode, newPassword))
                    .pipe(catchError(err => HandleAWSCognitoError(err)));
    }

    completeNewPassword(user: any, password: string): Observable<any> {
        configureAmplify(false);
        return from (Auth.completeNewPassword(user, password, {email: user.username}))
            .pipe(catchError(err => HandleAWSCognitoError(err)));
    }

    completeAgentNewPassword(user: any, email: string, password: string): Observable<any> {
        configureAmplify(false);
      return from(Auth.completeNewPassword(user, password, null)) //
            .pipe(catchError(err => HandleAWSCognitoError(err)));
    }

    register(username: string, password: string, email: string): Observable<ISignUpResult | ErrorResponse> {
        configureAmplify(false);
        return from( Auth.signUp({ username, password,
                        attributes: {
                            email : email,
                        },
                    })).pipe(catchError(err => HandleAWSCognitoError(err)));
    }

    // TODO: Remove the below method - Used for seed data
    // registerAgent(username: string, password: string, email: string): Observable<ISignUpResult | ErrorResponse> {
    //     configureAmplify(true);
    //     return from( Auth.signUp({ username, password,
    //                     attributes: {
    //                         email : email,
    //                     },
    //                 })).pipe(catchError(err => HandleAWSCognitoError(err)));
    // }

    registerAgent(username: string, password: string): Observable<any> {
        configureAmplify(true);

        return from( Auth.signIn(username, password))
                .pipe(catchError(err => HandleAWSCognitoError(err)));

    }

    confirmRegistration(username: string, verificationCode: string): Observable<any> {

        // Auth.configure(AuthConfig);
        configureAmplify(false);

        return from (Auth.confirmSignUp(username, verificationCode))
                .pipe(catchError(err => HandleAWSCognitoError(err)));
    }



    confirmAgentRegistration(username: string, verificationCode: string): Observable<any> {

        // Auth.configure(AgentAuthConfig);
        configureAmplify(true);
        return from (Auth.confirmSignUp(username, verificationCode))
                .pipe(catchError(err => HandleAWSCognitoError(err)));
    }

    // confirmRegistrationAgent(username: string, verificationCode: string): Observable<any> {

    //    Auth.configure(AgentAuthConfig);
    //    return from (Auth.confirmSignUp(username, verificationCode))
    //            .pipe(catchError(err => HandleAWSCognitoError(err)));
    // }


    GetCurrentUser(): Observable<any>  {

        return this.http.get(`${this.baseURL}/registrations/current-registration`)
        .pipe(
            catchError(err => HandleHttpError(err))
        );
    }

    validateUser(familyName: string, dateOfBirth: string, emailAddress: string, countryCode: string ): Observable<any>  {
        let params = new HttpParams();
        params = params.append('FamilyName', familyName);
        params = params.append('DateOfBirth', dateOfBirth);
        params = params.append('EmailAddress', emailAddress);
        params = params.append('CountryCode', countryCode);

        return this.http.get(`${this.baseURL}/registrations/validate-registration`, { params: params})
                        .pipe(
                            catchError(err => HandleHttpError(err))
                        );

    }

    registerNewUser(familyName: string, givenName: string, dateOfBirth: string, email: string): Observable<any> {
        const body = {
            'EmailAddress': email,
            'DateOfBirth': dateOfBirth,
            'GivenName': givenName,
            'FamilyName': familyName
        };

        return this.http.post(`${this.baseURL}/registrations/register-user`, body)
        .pipe(
            catchError(err => HandleHttpError(err))
        );

    }

    getCurrentAuthenticatedUser(): Observable<any> {


        const userType = localStorage.getItem('userType');

        // if (userType && userType === 'agent') {
        //     Auth.configure(AgentAuthConfig);
        // } else  {
        //     Auth.configure(AuthConfig);
        // }

        configureAmplify(userType === 'agent');

        return from ( Auth.currentAuthenticatedUser())
                .pipe( catchError( err => HandleAWSCognitoError(err)));
    }

    getCurrentSession(): Observable<any> {
        return from (Auth.currentSession())
                .pipe( catchError( err => HandleAWSCognitoError(err)));
    }

    storeCognitoIdentityId(user: CognitoUser) {

        const userType = localStorage.getItem('userType');

        const awsSettings: AWSSettings = JSON.parse(localStorage.getItem('awsSettings'));

        // const identityPoolId = userType === 'student' ? AuthConfig.identityPoolId : AgentAuthConfig.identityPoolId;
        // const region = userType === 'student' ? AuthConfig.region : AgentAuthConfig.region;
        // const userPoolId = userType === 'student' ? AuthConfig.userPoolId : AgentAuthConfig.userPoolId;


        const identityPoolId = awsSettings.IdentityPoolId;
        const region = awsSettings.Region;
        const userPoolId = awsSettings.UserPoolId;

        const loginKey = `cognito-idp.${region}.amazonaws.com/${userPoolId}`;




        user.getSession(function(err, result) {
            if (result) {

                const logins = {};
                logins[loginKey] = result.getIdToken().getJwtToken();

                const awsCognitoIdentityCredentials = new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: identityPoolId,
                    Logins: logins
                });

                localStorage.setItem('identityId', awsCognitoIdentityCredentials.identityId);
            }
          });
    }

    verifyUserEmail(email: string): Observable<any> {
        return this.http.post(`${this.sharedService.getBaseURL()}/agent/verify-email?email=${email}`, {})
                        .pipe(catchError(err => HandleHttpError(err)));
    }

    forgotAgentPassword(email: string): Observable<any> {
        return this.http.post(`${this.sharedService.getBaseURL()}/agent/forgot-password?email=${email}`, {})
                        .pipe(catchError(err => HandleHttpError(err)));
    }  
    
    getToken(): Observable<any> {

        if(!localStorage.getItem('identityId'))
            return Observable.of('');
            
        return this.getCurrentSession().pipe(map(
            user => {
                // console.log(user);
                return user.getIdToken().getJwtToken();
                
            }
        ))
       
      }

}

